<template>
  <transition name="fade">
    <modal @close-modal="$emit('close-modal')">
      <div
        class="bg-white px-6 pt-4 pb-6 grid gap-8 justify-items-center w-full rounded-t-2xl text-center"
      >
        <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
        <div class="grid gap-6 justify-center justify-items-center w-full">
          <img src="../assets/upload-failed.svg" alt="Error" width="108" height="102" />
            <div class="grid px-4 gap-4">
              <p class="label-text-headingColor-myriad font-semibold">{{ errorPopupMessage?.message.primary }}</p>
              <p class="label-text-headingColor-myriad">Please contact support team <br/>
                <a class="underline text-primary font-bold"
                  @click="supportClicked()"
                  href="tel:+918100050505">
                  +91-8100050505
                </a>
              </p>
            </div>
        </div>
        <div class="grid w-full">
          <custom-button
            variant="primary"
            type="button"
            @click="$emit('close-modal')"
            :disabled="loading"
          >{{ errorPopupMessage?.message.primaryButtonTextEng }}</custom-button>
        </div>
      </div>
    </modal>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex';
import Modal from './Modal.vue';
import CustomButton from './CustomButton.vue';

export default {
  name: 'ErrorMessagePopup',
  components: {
    Modal,
    CustomButton,
  },
  computed: {
    ...mapGetters(['applicationId']),
  },
  props: {
    errorPopupMessage: {
      required: true,
      type: Object,
    },
    routeLink: {
      required: true,
      type: String,
    },
    actionButtonText: {
      required: true,
      type: String,
    },
    defaultContinueAnyways: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      loading: undefined,
    };
  },
  methods: {
    applicationContinueAnyway() {
      if (this.defaultContinueAnyways) {
        this.loading = true;
        this.$store
          .dispatch('applicationContinueAnyway', {
            applicationId: this.applicationId,
            queryParams: {
              review: !!this.$route.meta.isEdit,
            },
          })
          .then(() => {
            this.loading = false;
            this.$router.push({ name: this.routeLink });
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.$emit('continue-anyways');
      }
    },
    supportClicked() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SUPPORT_CLICKED, {
        [this.$mixpanelPayload.ERROR_REASON]: this.errorPopupMessage?.message.primary,
      });
    }
  },
};
</script>
